import { Box, Button, Grid, MobileStepper, useTheme } from "@mui/material";
import AccordianContainer from "../../CustomComponents/AccordianContainer";
import CustomTextField from "../../CustomComponents/CustomTextField";
import { KeyboardArrowLeft, KeyboardArrowRight } from "@mui/icons-material";
import { useState } from "react";
import { convertDateWithValidation, validate } from "../helper/losDataHelper";

const CollateralDetails = ({ collateralInformationList }) => {

  const theme = useTheme();
  const [activeStep, setActiveStep] = useState(0);

 const maxSteps = validate(collateralInformationList) ?  collateralInformationList.length : 0;

 const handleBack = () => {
   setActiveStep((prevActiveStep) => prevActiveStep - 1);
 };

 const handleNext = () => {
   setActiveStep((prevActiveStep) => prevActiveStep + 1);
 };


  const collateralInformationComponent = () => {
    const collateralInformation = validate(collateralInformationList) ? collateralInformationList[activeStep] : undefined;
    return(
      <Grid container rowSpacing={0} columnSpacing={2}>
         <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
               type="text"
               label="Collateral Assessment ID"
               variant="standard"
               placeholder="Enter Collateral Assessment ID"
               disabled={true}
               value={collateralInformation !== undefined ? collateralInformation.collateralAssessmentId : []}
             />
             </Grid>
             <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
               type="text"
               label="Internal Application ID"
               variant="standard"
               placeholder="Enter Internal Application ID"
               disabled={true}
               value={collateralInformation !== undefined ? collateralInformation.internalApplicationId : []}
             />
             </Grid>
             <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
               type="text"
               label="Internal Customer ID"
               variant="standard"
               placeholder="Enter Internal Customer ID"
               disabled={true}
               value={collateralInformation !== undefined ? collateralInformation.internalCustomerId : []}
             />
             </Grid>
             <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
               type="text"
               label="Customer ID"
               variant="standard"
               placeholder="Enter Customer ID"
               disabled={true}
               value={collateralInformation !== undefined ? collateralInformation.customerId : []}
             />
             </Grid>
             <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
               type="text"
               label="Property ID"
               variant="standard"
               placeholder="Enter Property ID"
               disabled={true}
               value={collateralInformation !== undefined ? collateralInformation.propertyId : []}
             />
             </Grid>
             <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
               type="text"
               label="Property Occupancy"
               variant="standard"
               placeholder="Enter Property Occupancy"
               disabled={true}
               value={collateralInformation !== undefined ? collateralInformation.propertyOccupancy : []}
             />
             </Grid>
             <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
               type="text"
               label="Property Owner Name"
               variant="standard"
               placeholder="Enter Property Owner Name"
               disabled={true}
               value={collateralInformation !== undefined ? collateralInformation.propertyOwnerName : []}
             />
             </Grid>
         <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
               type="text"
               label="Property Size"
               variant="standard"
               placeholder="Enter Property Size"
               disabled={true}
               value={collateralInformation !== undefined ? collateralInformation.propertySize : []}
             />
             </Grid>
             <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
               type="text"
               label="Property Type"
               variant="standard"
               placeholder="Enter Property Type"
               disabled={true}
               value={collateralInformation !== undefined ? collateralInformation.propertyType : []}
             />
             </Grid>
             <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
               type="text"
               label="Commercial Used House Part"
               variant="standard"
               placeholder="Enter Commercial Used House Part"
               disabled={true}
               value={collateralInformation !== undefined ? collateralInformation.commercialUsedHousePart : []}
             />
             </Grid>
             <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
               type="text"
               label="Coordinate Bco"
               variant="standard"
               placeholder="Enter Coordinate Bco"
               disabled={true}
               value={collateralInformation !== undefined ? collateralInformation.coordinateBco : []}
             />
             </Grid>
             <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
               type="text"
               label="Coordinates"
               variant="standard"
               placeholder="Enter Coordinates"
               disabled={true}
               value={collateralInformation !== undefined ? collateralInformation.coordinates : []}
             />
             </Grid>
             <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
               type="text"
               label="Count Floor"
               variant="standard"
               placeholder="Enter Count Floor"
               disabled={true}
               value={collateralInformation !== undefined ? collateralInformation.countFloor : []}
             />
             </Grid>
             <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
               type="text"
               label="Count Occupant"
               variant="standard"
               placeholder="Enter Count Occupant"
               disabled={true}
               value={collateralInformation !== undefined ? collateralInformation.countOccupant : []}
             />
             </Grid>
             <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
               type="text"
               label="Count Tenent"
               variant="standard"
               placeholder="Count Tenent"
               disabled={true}
               value={collateralInformation !== undefined ? collateralInformation.countTenent : []}
             />
             </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
               type="text"
               label="Floor Type"
               variant="standard"
               placeholder="Enter Floor Type"
               disabled={true}
               value={collateralInformation !== undefined ? collateralInformation.floorType : []}
             />
             </Grid>
             
             <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
               type="text"
               label="Is Any Coowner"
               variant="standard"
               placeholder="Enter Is Any Coowner"
               disabled={true}
               value={collateralInformation !== undefined ? collateralInformation.isAnyCoowner : []}
             />
             </Grid>
             <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
               type="text"
               label="Is Collateral Details Valid"
               variant="standard"
               placeholder="Enter Is Collateral Details Valid"
               disabled={true}
               value={collateralInformation !== undefined ? collateralInformation.isCollateralDetailsValid : []}
             />
             </Grid>
             <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
               type="text"
               label="Is Collateral Location Valid"
               variant="standard"
               placeholder="Enter Is Collateral Location Valid"
               disabled={true}
               value={collateralInformation !== undefined ? collateralInformation.isCollateralLocationValid : []}
             />
             </Grid>
             <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
               type="text"
               label="Is Portion For Commercial"
               variant="standard"
               placeholder="Enter Is Portion For Commercial"
               disabled={true}
               value={collateralInformation !== undefined ? collateralInformation.isPortionForCommercial : []}
             />
             </Grid>
             <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
               type="text"
               label="Is Portion Tenent Out"
               variant="standard"
               placeholder="Enter Is Portion Tenent Out"
               disabled={true}
               value={collateralInformation !== undefined ? collateralInformation.isPortionTenentOut : []}
             />
             </Grid>
             <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
               type="text"
               label="Month Of Stay"
               variant="standard"
               placeholder="Enter Month Of Stay"
               disabled={true}
               value={collateralInformation !== undefined ? collateralInformation.monthOfStay : []}
             />
             </Grid>
             <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
               type="text"
               label="Year Of Stay"
               variant="standard"
               placeholder="Enter Year Of Stay"
               disabled={true}
               value={collateralInformation !== undefined ? collateralInformation.yearOfStay : []}
             />
             </Grid>  
             <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
               type="text"
               label="Nature Of Property"
               variant="standard"
               placeholder="Enter Nature Of Property"
               disabled={true}
               value={collateralInformation !== undefined ? collateralInformation.natureOfProperty : []}
             />
             </Grid>
             <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
               type="text"
               label="Owner Of The Property"
               variant="standard"
               placeholder="Enter Owner Of The Property"
               disabled={true}
               value={collateralInformation !== undefined ? collateralInformation.ownerOfTheProperty : []}
             />
             </Grid>
             <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
               type="text"
               label="Remarks"
               variant="standard"
               placeholder="Enter Remarks"
               disabled={true}
               value={collateralInformation !== undefined ? collateralInformation.remarks : []}
             />
             </Grid>
             <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
               type="text"
               label="Rented Out House Part"
               variant="standard"
               placeholder="Enter Rented Out House Part"
               disabled={true}
               value={collateralInformation !== undefined ? collateralInformation.rentedOutHousePart : []}
             />
             </Grid>
             <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
               type="text"
               label="Rented Portion Utilization"
               variant="standard"
               placeholder="Enter Rented Portion Utilization"
               disabled={true}
               value={collateralInformation !== undefined ? collateralInformation.rentedPortionUtilization : []}
             />
             </Grid>
             <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
               type="text"
               label="Resident Contact Number"
               variant="standard"
               placeholder="Enter Resident Contact Number"
               disabled={true}
               value={collateralInformation !== undefined ? collateralInformation.residentContactNumber : []}
             />
             </Grid>
             <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
               type="text"
               label="Resident Name"
               variant="standard"
               placeholder="Enter Resident Name"
               disabled={true}
               value={collateralInformation !== undefined ? collateralInformation.residentName : []}
             />
             </Grid>
             <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
               type="text"
               label="Roof Type"
               variant="standard"
               placeholder="Enter Roof Type"
               disabled={true}
               value={collateralInformation !== undefined ? collateralInformation.roofType : []}
             />
             </Grid>
             <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Created By"
                variant="standard"
                placeholder="Enter Created By"
                disabled={true}
                value={collateralInformation !== undefined ? collateralInformation.createdBy : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Modified By"
                variant="standard"
                placeholder="Enter Modified By"
                disabled={true}
                value={collateralInformation !== undefined ? collateralInformation.modifiedBy : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Created Date"
                variant="standard"
                placeholder="Enter Created Date"
                disabled={true}
                value={collateralInformation !== undefined ? convertDateWithValidation(collateralInformation.createdDate) : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Modified Date"
                variant="standard"
                placeholder="Enter Modified Date"
                disabled={true}
                value={collateralInformation !== undefined ? convertDateWithValidation(collateralInformation.modifiedDate) : ""}
              />
              </Grid>
             </Grid>
    );
  }
    return(<>
        <AccordianContainer
         id="accord"
         title="Collateral Details"
         initialOpen={false}
       >
       <Box sx={{ marginTop: "-1%" }}>
       <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                         <Box sx={{ display: "flex", justifyContent:"center", alignItems: "center", marginBottom: "8px"}}>
                        { maxSteps > 1 && <MobileStepper
                          variant="text"
                          steps={maxSteps}
                          position="static"
                          activeStep={activeStep}
                          sx={{ maxWidth: 400, flexGrow: 1, boxShadow: 2 }} 
                            nextButton={
                            <Button size="small" sx={{ color:"#003f7c" }} onClick={handleNext} disabled={activeStep === maxSteps - 1}>
                                Next
                            {theme.direction === 'rtl' ? (
                            <KeyboardArrowLeft />
                            ) : ( <KeyboardArrowRight /> )}
                           </Button>
                         }
                        backButton={
                        <Button size="small" onClick={handleBack} sx={{ color:"#003f7c" }} disabled={activeStep === 0}>
                        {theme.direction === 'rtl' ? (
                            <KeyboardArrowRight />
                        ) : (
                            <KeyboardArrowLeft />
                        )}
                            Back
                        </Button>
                    }
                    /> }
                    </Box>
                    </Grid>
                    { collateralInformationComponent() }
        </Box>
       </AccordianContainer>
   </>);
}

export default CollateralDetails;